import { getPublicRuntimeConfig } from "./publicConfig";

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

let analyticsReady = false;
let initPromise: Promise<boolean> | null = null;

function injectGtagScript(measurementId: string) {
  if (!document.getElementById("ga4-gtag-script")) {
    const script = document.createElement("script");
    script.id = "ga4-gtag-script";
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=" + encodeURIComponent(measurementId);
    document.head.appendChild(script);
  }

  if (!window.dataLayer) window.dataLayer = [];
  if (!window.gtag) {
    window.gtag = function gtag(...args: unknown[]) {
      window.dataLayer!.push(args);
    };
  }

  window.gtag("js", new Date());
  window.gtag("config", measurementId, { send_page_view: false });
}

export function initializeGoogleAnalytics(): Promise<boolean> {
  if (initPromise) return initPromise;

  initPromise = getPublicRuntimeConfig().then((config) => {
    if (!config.analyticsEnabled || !config.gaMeasurementId) return false;
    injectGtagScript(config.gaMeasurementId);
    analyticsReady = true;
    return true;
  });

  return initPromise;
}

export function trackGooglePageView(path: string) {
  if (!analyticsReady || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.origin + path,
    page_title: document.title,
  });
}

export function trackGoogleEvent(name: string, params?: Record<string, unknown>) {
  if (!analyticsReady || !window.gtag) return;
  window.gtag("event", name, params || {});
}
